@if (isModalOpen()) {
<modal
  [id]="id()"
  [header]="header()"
  [headerIcon]="headerIcon()"
  [closeButtonEnabled]="true"
  [enableBackdropClose]="true"
  [showHeaderDivider]="true"
  [showFooterDivider]="false"
  [widthClass]="'tw-w-11/12 tw-max-w-sm md:tw-max-w-xl lg:tw-max-w-4xl'"
  [heightClass]="'tw-h-auto tw-max-h-[90vh]'"
  (onCloseModal)="closeModal()"
>
  <!-- Body: Cropper Content -->
  <div slot="body" class="tw-flex-1 tw-overflow-hidden tw-flex tw-flex-col tw-min-h-0 tw-relative">
    @if (imageFile()) {
      <cropper
        [imageFile]="imageFile()!"
        [aspectRatio]="aspectRatio()"
        [initialCropBox]="initialCropBox()"
        (cropped)="onImageCropped($event)"
        (cancelled)="closeModal()"
        (loadFailed)="onLoadFailed()"
        (imageLoaded)="onImageLoaded()"
        class="tw-flex-1 tw-w-full tw-min-h-0"
      ></cropper>
      @if (!imageReady()) {
        <div class="tw-absolute tw-inset-0 tw-flex tw-items-center tw-justify-center tw-bg-gray-100 tw-z-10">
          <progress-circle [isInfinite]="true" colorClasses="tw-border-blue-500 tw-border-r-gray-300"></progress-circle>
        </div>
      }
    }
  </div>

  <!-- Footer: Apply Button -->
  <div slot="footer" class="tw-px-6 tw-pb-6">
    <button 
      type="button"
      (click)="triggerCrop()"
      class="tw-w-full tw-py-3 tw-px-5 tw-rounded-lg tw-text-base tw-font-medium tw-text-white tw-bg-blue-600 hover:tw-bg-blue-700 tw-transition-colors tw-cursor-pointer"
    >
      Apply
    </button>
  </div>
</modal>
}
